import { Controller } from "@hotwired/stimulus"

// Lets the user add competitors by hand when auto-discovery misses one (or comes
// up empty). Each add appends a removable chip backed by a hidden
// custom_competitors[] field that the watchlist form submits. Server-side
// re-validates and resolves to a real company, so this is just convenience UI.
export default class extends Controller {
  static targets = ["input", "list", "template", "error"]

  add(event) {
    event.preventDefault()
    const value = this.normalize(this.inputTarget.value)
    if (!value) return this.showError()
    if (this.has(value)) return this.clear()

    const node = this.templateTarget.content.firstElementChild.cloneNode(true)
    node.dataset.value = value
    node.querySelector("[data-label]").textContent = value
    node.querySelector("input[type=hidden]").value = value
    this.listTarget.appendChild(node)
    this.clear()
  }

  remove(event) {
    event.currentTarget.closest("[data-value]")?.remove()
  }

  keydown(event) {
    if (event.key === "Enter") this.add(event)
  }

  clear() {
    this.inputTarget.value = ""
    this.inputTarget.focus()
    this.hideError()
  }

  has(value) {
    return [...this.listTarget.querySelectorAll("[data-value]")].some((el) => el.dataset.value === value)
  }

  showError() {
    if (this.hasErrorTarget && this.inputTarget.value.trim()) this.errorTarget.classList.remove("hidden")
  }

  hideError() {
    if (this.hasErrorTarget) this.errorTarget.classList.add("hidden")
  }

  // A LinkedIn company URL is kept as-is; otherwise reduce to a bare domain and
  // accept it only if it looks like one. Returns "" for anything else.
  normalize(raw) {
    const value = (raw || "").trim()
    if (!value) return ""
    if (/linkedin\.com\/company\//i.test(value)) return value.replace(/\/+$/, "")

    const domain = value
      .toLowerCase()
      .replace(/^https?:\/\//, "")
      .replace(/^www\./, "")
      .replace(/[/?#].*$/, "")
      .replace(/\.$/, "")
    return /^[a-z0-9-]+(\.[a-z0-9-]+)+$/.test(domain) ? domain : ""
  }
}
